<template>
  <div class="layout-default">
    <main class="layout-default__main">
      <slot />
    </main>
    <footer class="layout-default__footer"></footer>
    <div class="layout-default__env" v-if="debug">
      <p>当前环境： {{ env }}</p>
    </div>
  </div>
</template>
<script lang="ts">
import 'normalize.css'
import vConsole from 'vconsole'
import env from '@/core/utils/env'
import { getUserInfo } from '@/core/jsapi'
import request from '@/core/request'
import { auth } from '@/core/api'
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'LayoutDefault',
  setup() {
    const debug = ref(false)
    const store = useStore()

    const loadUserInfo = () => {
      request(auth).then(res => {
        const { code, data } = res
        if (!code) {
          store.commit('setIsLogin', true)
          store.commit('setCoin', data.jinbi)
          store.commit('setRedpack', data.redpack)
          store.commit('setUserInfo', data)
        }
      })
    }

    const loadClientInfo = async () => {
      getUserInfo().then((data: any) => {
        store.commit('setUserInfo', {
          nick: data.name,
          // eslint-disable-next-line @typescript-eslint/camelcase
          face_url: data.icon
        })
      })
    }

    onMounted(() => {
      const { documentElement } = document
      console.log(
        `current page width: ${documentElement.clientWidth}, current page height: ${documentElement.clientHeight}, dpr=${window.devicePixelRatio}`
      )
      if (env === 'testing' || env === 'pre') {
        // eslint-disable-next-line new-cap
        // new vConsole()
        debug.value = true
      }
      loadUserInfo()
      loadClientInfo()
    })

    return {
      env,
      debug
    }
  }
}
</script>
<style lang="scss">
@font-face {
  font-family: 'DINAlternate';
  src: url('https://gh.gtimg.com/fonts/din_alternate_bold-webfont.woff2') format('woff2'),
    url('https://gh.gtimg.com/fonts/din_alternate_bold-webfont.woff') format('woff');
}

@font-face {
  font-family: 'TTTGB';
  src: url('https://gh.gtimg.com/owhat/dist/fonts/Tencent-W7.ttf') format('truetype');
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  font-family: din_alternatebold, 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-size: 12px;
  color: #000;
  word-spacing: 1px;
  text-size-adjust: 100%;
  text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: transparent;
  appearance: none;
}

body * {
  user-select: none;
}

body input,
body textarea {
  user-select: text;
}
input[type='text'] {
  /* Remove First */
  appearance: none;
  appearance: none;
  appearance: none;
  outline: none;

  /* Then Style */
  border-radius: 15px;
  border: 1px dashed #bbb;
  padding: 10px;
  line-height: 20px;
  text-align: center;
  background: transparent;
}
img {
  display: block;
  border: 0;
  max-width: 100%;
  max-height: 100%;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
a {
  color: inherit;
  text-decoration: none;
}
h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flex-ct-x,
.flex-ct-y {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-ct-y {
  flex-direction: column;
}

.pa-ct {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.layout-default {
  &__env {
    position: fixed;
    left: 0px;
    bottom: 44px;
    border-radius: 3px;
    font-size: 12px;
    z-index: 9999;
    font-weight: 600;
    color: #f00;
    background: rgba(0, 0, 0, 0.5);
    padding: 5px;
  }
}
</style>
